import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveDistributionRegion } from "./distributionRegionActions";
import { GetDistributionRegion } from "./distributionRegionTypes";

// Api's
import { distributionRegionApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getDistributionRegionSaga(action: GetDistributionRegion) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			distributionRegionApi.getDomain,
			action.payload.request,
		);

		if (response.data.result) {
			yield put(saveDistributionRegion(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveDistributionRegion(null, true, resultError.messagesDataError));
		}
	}
}
